import * as React from 'react';
import { style } from 'typestyle';
import { colorWhite } from '../theme/color';
import { em, px } from 'csx';
import { mediaMobileOnly, mediaTablet } from '../theme/media';
import { constants as justAddedConstants, PageHomeJustAddedTracks } from './page-home-just-added-tracks';
import { observer } from 'mobx-react';
import { fontHeading } from '../theme/font';
import { center, horizontal, horizontallySpaced } from 'csstips';
import { ArtistSchema, TrackSchema } from '../types/schema';
import { ImagePreloader } from '../types/fn';
import { AnalyticsController } from '../modules/analytics/controller';

export interface PageHomeJustAddedProps {
  model: TrackSchema[];
  onClickLink(event: React.MouseEvent<any>): void;
  preload: ImagePreloader;
  PlayButton: any;
  AddRemove: any;
  Favourite: any;
  i18n?: {
    title: string;
  };
  href?: string;
  analytics: AnalyticsController;
}

@observer
export class PageHomeJustAdded extends React.Component<PageHomeJustAddedProps, any> {
  render() {
    const {
      i18n = PageHomeJustAdded.i18n,
      href,
      model,
      PlayButton,
      Favourite,
      AddRemove,
      onClickLink,
      preload,
      analytics,
    } = this.props;

    return (
      <div className={PageHomeJustAdded.styles.container}>
        <div className={PageHomeJustAdded.styles.titleWrapper}>
          <span className={PageHomeJustAdded.styles.title}>{i18n.title}</span>
          {href && (
            <a href={href} className={PageHomeJustAdded.styles.link} onClick={onClickLink}>
              View all
            </a>
          )}
        </div>
        <PageHomeJustAddedTracks
          analytics={analytics}
          tracks={model}
          PlayButton={PlayButton}
          AddRemove={AddRemove}
          Favourite={Favourite}
          onClickLink={onClickLink}
          preload={preload}
        />
      </div>
    );
  }

  static i18n = {
    title: 'Just added',
  };

  static styles = {
    container: style({
      position: 'relative',
      color: colorWhite.toString(),
    }),
    titleWrapper: style(
      {
        ...horizontal,
        ...horizontallySpaced(5),
        ...center,
        justifyContent: 'space-between',
        margin: 0,
        marginBottom: '20px',
      },
      mediaMobileOnly({
        marginLeft: '20px',
        width: justAddedConstants.mobileSize,
      }),
      mediaTablet({
        marginLeft: '40px',
        width: justAddedConstants.desktopSize,
      }),
    ),
    title: style({
      fontSize: px(20),
      fontFamily: fontHeading,
      fontWeight: 500,
      letterSpacing: em(-0.0625),
    }),
    link: style({
      textDecoration: 'underline',
    }),
  };
}
